import { FC, ReactNode } from 'react';
import cx from 'classnames/bind';
import { motion, AnimatePresence } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';

import { Button } from '@/components/Button';

import styles from './Modal.module.scss';

interface ModalProps {
  handleClick?: () => void;
  src: string;
  title: string;
  textButton: string;
  children: ReactNode;
}

const cn = cx.bind(styles);

const Modal: FC<ModalProps> = ({
  handleClick,
  src,
  title,
  textButton,
  children,
}) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1392px)' });

  return (
    <div className={cn('container')}>
      <AnimatePresence>
        <motion.button
          initial={{ y: 0, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 0, opacity: 0 }}
          transition={{
            duration: isDesktop ? 1 : 0.5,
            delay: isDesktop ? 1 : 0,
            ease: 'backInOut',
          }}
          type="button"
          onClick={handleClick}
          className={cn('overlay')}
        />
      </AnimatePresence>
      <div className={cn('empty-space')} />
      <AnimatePresence>
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{
            duration: isDesktop ? 1 : 0.5,
            delay: isDesktop ? 1 : 0,
            ease: 'backInOut',
          }}
          className={cn('content')}
        >
          <div className={cn('wrap')}>
            <img className={cn('img')} src={src} alt="" />
            <h2 className={cn('title')}>{title}</h2>
            {children}
            <div className={cn('wrapper')}>
              <Button handleClick={handleClick}>{textButton}</Button>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
      <div className={cn('empty-space')} />
    </div>
  );
};

export default Modal;
